import { stdObject } from "../data/types/stdObject";
import { sendData } from "./sendData";

export const callDocuments = async ({
  user,
  code,
  ser,
  warehouse,
  dateCode = "FEC",
  startDate = "",
  days,
  dates = [],
  sort = false,
  search = {},
  print = false,
  mainHeader = [],
  logoutAction,
}: {
  user: number;
  code: string;
  ser: number;
  warehouse: number;
  dateCode?: string;
  startDate?: string;
  days?: number;
  dates?: Array<string>;
  sort?: stdObject | boolean;
  search?: stdObject;
  print?: boolean;
  mainHeader?: Array<stdObject>;
  logoutAction: any;
}) => {
  code = ["c2", "c3"].includes(code) ? "sev" : code;
  code = ["b3"].includes(code) ? "caj" : code;
  code = ["f2"].includes(code) ? "art" : code;
  const payloadDocService = {
    user,
    code,
    ser,
    dateCode,
    startDate,
    days,
    dates,
    sort,
    print,
    warehouse,
    items: mainHeader.some((e: stdObject) => e.CODCAB === "ITEMS"),
    search: Object.entries(search)
      .filter(
        ([key, e]: [string, stdObject]) =>
          key !== "SORT" && !key.startsWith("FEC") && e.value !== "",
      )
      .map(([key, e]: [string, stdObject]) => {
        const { value, value2, mode } = e;
        return { key, value, value2, mode };
      }),
  };
  // console.log("payloadDocService", payloadDocService);

  const responseDocService: {
    [key: string]: any;
  } = await sendData({
    endPoint: "callDocumentsList",
    payload: payloadDocService,
    logoutAction,
  });
  // console.log("responseDocService", responseDocService);

  if (responseDocService.success) {
    return responseDocService.list;
  } else {
    return [];
  }
};
